module.exports = __webpack_public_path__ + "static/media/12.14add0e4.png";